import { render, staticRenderFns } from "./IconTagLg.vue?vue&type=template&id=5cd34642&"
import script from "./IconTagLg.vue?vue&type=script&lang=js&"
export * from "./IconTagLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd34642')) {
      api.createRecord('5cd34642', component.options)
    } else {
      api.reload('5cd34642', component.options)
    }
    module.hot.accept("./IconTagLg.vue?vue&type=template&id=5cd34642&", function () {
      api.rerender('5cd34642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTagLg.vue"
export default component.exports